module.exports = __webpack_public_path__ + "img/task_nav_01.84726344.png";